import type AcquireTokenCallback from '../schema/AcquireTokenCallback';
import acquireTokenFromAuthContext from './acquireTokenFromAuthContext';
// Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
// -> Error TS7016 (6,40): Could not find a declaration file for module 'adal-angular'. 'node_modules/adal-angular/lib/adal.js' implicitly has an 'any' type.
// @ts-expect-error
import type AuthenticationContext from 'adal-angular';

export let aquireTokenAfterLogin = (
    authContext: AuthenticationContext,
    resource: string,
    authChallenge: string,
    allowConsentPrompt: boolean,
    getAccessTokenCallback: AcquireTokenCallback
) => (loginError: string | null, idToken: string | null): void => {
    if (loginError || !idToken) {
        getAccessTokenCallback(loginError, null /* token */);
    } else {
        authContext.getCachedUser();
        acquireTokenFromAuthContext(
            authContext,
            resource,
            authChallenge,
            allowConsentPrompt,
            getAccessTokenCallback
        );
    }
};
